// client/src/admin/dataProvider.js
const API = process.env.REACT_APP_API_BASE_URL;

const http = async (url, options = {}) => {
  const token = localStorage.getItem('token');
  const headers = {
    ...(options.headers || {}),
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
  const res = await fetch(url, { ...options, headers });
  if (!res.ok) {
    let err = {};
    try { err = await res.json(); } catch {}
    const e = new Error(err.error || `HTTP ${res.status}`);
    e.status = res.status;
    throw e;
  }
  // 204?
  if (res.status === 204) return null;
  try { return await res.json(); } catch { return null; }
};

export const dataProvider = {
  // GET_LIST
  getList: async (resource, params) => {
    switch (resource) {
      case 'fornitori': {
        const data = await http(`${API}/api/admin/fornitori`);
        return { data, total: data.length };
      }
      case 'servizi': {
        // Possibile filtro per id_fornitore
        const { filter } = params;
        if (filter && filter.id_fornitore) {
          const d = await http(`${API}/api/admin/servizi/fornitore/${filter.id_fornitore}`);
          return { data: d, total: d.length };
        }
        const d = await http(`${API}/api/admin/servizi`);
        return { data: d, total: d.length };
      }
      case 'fasceOrarie': {
        const { filter } = params;
        if (filter && filter.id_fornitore) {
          const d = await http(`${API}/api/fasce-orarie/fornitore/${filter.id_fornitore}`);
          return { data: d, total: d.length };
        }
        const d = await http(`${API}/api/fasce-orarie`);
        return { data: d, total: d.length };
      }
      default:
        throw new Error(`Risorsa non supportata: ${resource}`);
    }
  },

  // GET_ONE
  getOne: async (resource, params) => {
    const { id } = params;
    if (resource === 'fornitori') {
      const d = await http(`${API}/api/admin/fornitori/${id}`);
      return { data: d };
    }
    if (resource === 'servizi') {
      const d = await http(`${API}/api/admin/servizi/${id}`);
      return { data: d };
    }
    if (resource === 'fasceOrarie') {
      const d = await http(`${API}/api/fasce-orarie/${id}`);
      return { data: d };
    }
    throw new Error(`getOne non supportato per ${resource}`);
  },

  // CREATE
  create: async (resource, params) => {
    if (resource === 'fornitori') {
      const d = await http(`${API}/api/admin/fornitori`, {
        method: 'POST',
        body: JSON.stringify(params.data),
      });
      return { data: d };
    }
    if (resource === 'servizi') {
      const d = await http(`${API}/api/admin/servizi`, {
        method: 'POST',
        body: JSON.stringify(params.data),
      });
      return { data: d };
    }
    if (resource === 'fasceOrarie') {
      const d = await http(`${API}/api/fasce-orarie`, {
        method: 'POST',
        body: JSON.stringify(params.data),
      });
      return { data: d };
    }
    throw new Error(`create non supportato per ${resource}`);
  },

  // UPDATE
  update: async (resource, params) => {
    const { id, data } = params;
    if (resource === 'fornitori') {
      const d = await http(`${API}/api/admin/fornitori/${id}`, {
        method: 'PUT',
        body: JSON.stringify(data),
      });
      return { data: d };
    }
    if (resource === 'servizi') {
      const d = await http(`${API}/api/admin/servizi/${id}`, {
        method: 'PUT',
        body: JSON.stringify(data),
      });
      return { data: d };
    }
    if (resource === 'fasceOrarie') {
      const d = await http(`${API}/api/fasce-orarie/${id}`, {
        method: 'PUT',
        body: JSON.stringify(data),
      });
      return { data: d };
    }
    throw new Error(`update non supportato per ${resource}`);
  },

  // DELETE
  delete: async (resource, params) => {
    const { id } = params;
    if (resource === 'fornitori') {
      await http(`${API}/api/admin/fornitori/${id}`, { method: 'DELETE' });
      return { data: { id } };
    }
    if (resource === 'servizi') {
      await http(`${API}/api/admin/servizi/${id}`, { method: 'DELETE' });
      return { data: { id } };
    }
    if (resource === 'fasceOrarie') {
      await http(`${API}/api/fasce-orarie/${id}`, { method: 'DELETE' });
      return { data: { id } };
    }
    throw new Error(`delete non supportato per ${resource}`);
  },

  // Non implementiamo bulk ed altri metodi per ora
  getMany: async () => ({ data: [] }),
  getManyReference: async () => ({ data: [], total: 0 }),
  updateMany: async () => ({ data: [] }),
  deleteMany: async () => ({ data: [] }),
};
